import { render, staticRenderFns } from "./DashboardProveedor.vue?vue&type=template&id=716a07c5&scoped=true"
import script from "./DashboardProveedor.vue?vue&type=script&lang=js"
export * from "./DashboardProveedor.vue?vue&type=script&lang=js"
import style0 from "./DashboardProveedor.vue?vue&type=style&index=0&id=716a07c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716a07c5",
  null
  
)

export default component.exports